import React from "react";
import classes from './Score.module.css'
import useScoreLevelColor from '../../../../../../../hooks/useScoreLevelColor'
import StudentScoreClasses from "./StudentScore.module.css"


const Score = ({ submission }) => {
    const levelColor = useScoreLevelColor();
    return (
        <div >
            {submission.status  && submission.status != "NotStarted" ? <div className={`${classes.Score} ${StudentScoreClasses.HoverClass}`} style={{ background: `${levelColor(submission.score * 100, submission.status).BColor}` }}>{`${submission.status == "Completed" ? Math.round(submission.score * 100) : ''}`}</div>
                : <div className={`${classes.Score} ${classes.EmptyScore}`}></div>}
        </div>
    )
}

export default Score;